import React from 'react';
import './SettingsMenu.css';

const ToggleField = ({ label, value, onChange, trueLabel = 'On', falseLabel = 'Off' }) => (
  <div className="cq-settings-field">
    <div className="cq-settings-field__copy">
      <label className="cq-settings-field__label">{label}</label>
    </div>
    <div className="cq-settings-toggle" role="group" aria-label={label}>
      <button
        type="button"
        className={`cq-settings-toggle__option${value ? ' is-selected' : ''}`}
        onClick={() => onChange(true)}
      >
        {trueLabel}
      </button>
      <button
        type="button"
        className={`cq-settings-toggle__option${!value ? ' is-selected' : ''}`}
        onClick={() => onChange(false)}
      >
        {falseLabel}
      </button>
    </div>
  </div>
);

const SettingsMenu = ({
  audioMode = 'pushToTalk',
  setAudioMode,
  showLeaderBoard,
  setShowLeaderBoard,
  onClose,
  onSave,
  onSignOut,
  onOpenAdmin,
  showIntro,
  setShowIntro,
  loading = false,
  signOutLoading = false,
  isAdmin = false,
}) => {
  return (
    <div
      className="settings-modal cq-settings-modal"
      style={{
        '--cq-settings-bg': `url(${process.env.PUBLIC_URL}/images/bg_artdeco_pattern_maroon.png)`,
        '--cq-settings-brass': `url(${process.env.PUBLIC_URL}/images/brass_plate_button.png)`,
      }}
    >
      <div className="cq-settings-header">
        <h2 className="cq-settings-title">Settings</h2>
        <button
          type="button"
          className="cq-settings-action-button cq-settings-action-button--close"
          onClick={onClose}
          aria-label="Close settings"
        >
          Close
        </button>
      </div>

      <div className="cq-settings-body">
        <div className="cq-settings-field">
          <div className="cq-settings-field__copy">
            <label className="cq-settings-field__label">Audio Mode</label>
          </div>
          <div className="cq-settings-toggle" role="group" aria-label="Audio Mode">
            <button
              type="button"
              className={`cq-settings-toggle__option${audioMode === 'pushToTalk' ? ' is-selected' : ''}`}
              onClick={() => setAudioMode?.('pushToTalk')}
            >
              Push to Talk
            </button>
            <button
              type="button"
              className={`cq-settings-toggle__option${audioMode === 'mute' ? ' is-selected' : ''}`}
              onClick={() => setAudioMode?.('mute')}
            >
              Mute
            </button>
          </div>
        </div>

        {/* Conversation Mode intentionally commented out because it is no longer part of the active UI flow. */}
        {/*
        <div className="cq-settings-field">
          ...
        </div>
        */}

        <ToggleField
          label="Show Leader Board"
          value={showLeaderBoard}
          onChange={setShowLeaderBoard}
          trueLabel="Show"
          falseLabel="Hide"
        />

        <ToggleField
          label="Show Intro"
          value={showIntro}
          onChange={setShowIntro}
          trueLabel="Show"
          falseLabel="Skip"
        />
      </div>

      <div className="cq-settings-actions">
        {isAdmin ? (
          <button
            type="button"
            className="cq-settings-action-button cq-settings-action-button--admin"
            onClick={onOpenAdmin}
            disabled={loading || signOutLoading}
          >
            Open Admin
          </button>
        ) : null}
        <button
          type="button"
          className="cq-settings-action-button"
          onClick={onSignOut}
          disabled={loading || signOutLoading}
        >
          {signOutLoading ? 'Signing out...' : 'Sign Out'}
        </button>
        <button
          type="button"
          className="cq-settings-save"
          onClick={onSave}
          disabled={loading || signOutLoading}
        >
          <span className="cq-settings-save__plate" aria-hidden="true" />
          <span className="cq-settings-save__label">
            {loading ? 'Saving...' : 'Save Settings'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default SettingsMenu;
